import * as Sentry from '@sentry/react';
import {
	QueryCache,
	QueryClient,
	QueryClientProvider,
} from '@tanstack/react-query';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './index.css';
import { notificationService } from './services/notification.service';

import router from '@configs/react-router';

const enableSentry = import.meta.env.MODE === 'production';

if (enableSentry) {
	Sentry.init({
		dsn: import.meta.env.VITE_SENTRY_URI,
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration(),
		],

		tracesSampleRate: +(import.meta.env.VITE_SENTRY_TRACE_RATE || 0.1),
		environment: import.meta.env.MODE,

		replaysSessionSampleRate: 0.1,
		replaysOnErrorSampleRate: 1.0,
	});
}
const queryClient = new QueryClient({
	queryCache: new QueryCache({
		onError(error, query) {
			if (query !== undefined) {
				notificationService.error(error.message);
			}
		},
	}),
});

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
	<QueryClientProvider client={queryClient}>
		<RouterProvider router={router} />
		<div data-test="toast-container">
			<ToastContainer data-test="toast-container" />
		</div>
	</QueryClientProvider>,
);
